import { render, staticRenderFns } from "./VipBuy.vue?vue&type=template&id=f4b14b1e&scoped=true"
import script from "./VipBuy.vue?vue&type=script&lang=js"
export * from "./VipBuy.vue?vue&type=script&lang=js"
import style0 from "./VipBuy.vue?vue&type=style&index=0&id=f4b14b1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b14b1e",
  null
  
)

export default component.exports